<template>
  <div>
    <table v-if="lineage.length" class="lx-mtable" aria-label="Data lineage">
      <thead>
        <tr>
          <th scope="col">Series</th><th scope="col">Source</th><th scope="col">Last obs.</th><th scope="col">Updated</th><th scope="col" class="num">Missing (52w)</th><th scope="col" class="num">Interpolated</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="l in lineage" :key="l.series">
          <td>{{ l.series }}</td>
          <td>{{ l.source }}<span v-if="l.identifier" class="lx-method"> · {{ l.identifier }}</span></td>
          <td>{{ l.lastObservation || "—" }}</td>
          <td><template v-if="l.updatedAt">{{ l.updatedAt }}</template><span v-else class="na">not recorded</span></td>
          <td class="num">{{ l.missingLast52 != null ? l.missingLast52 : "—" }}</td>
          <td class="num"><template v-if="l.interpolated != null">{{ l.interpolated }}</template><span v-else class="na">not recorded</span></td>
        </tr>
      </tbody>
    </table>
    <p v-else class="lx-method">{{ emptyText }}</p>
  </div>
</template>

<script>
export default {
  name: "ForecastDataLineage",
  props: {
    lineage: { type: Array, default: () => [] },
    emptyText: { type: String, default: "Lineage is not provided by the backend for this country." },
  },
};
</script>
